var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tva-video-lazy"},[_c('LazyVideo',{attrs:{"src":("" + _vm.baseUrl + (_vm.content.src)),"poster":("" + _vm.baseUrl + (_vm.content.poster))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }